export const MAX_WIDTH = '1440px';
export const MAX_CONTENT_WIDTH = '1256px';

export enum HeaderHeights {
  NAV = 36,
  MAIN = 56
}
